module.exports = __webpack_public_path__ + "img/kankou_24.cd7cd651.jpg";